var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"recom"}},[_c('keep-alive',{attrs:{"include":_vm.includeAlive}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }